module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fmtitle"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("AFT")]), _vm._v(" "), _c('td', {
    staticClass: "noindentz"
  }, [_vm._v("Bureau of Alcohol, Firearms, Tobacco and Explosives")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("CIA")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("Central Intelligence Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("DA")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("District Attorney")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("DEA")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("Drug Enforcement Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("FBI")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("Federal Bureau of Investigation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("HSCA")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("House Select Committee on Assassinations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("LAPD")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("Los Angeles Police Department")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("MLK")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("Martin Luther King Jr")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "noindent"
  }, [_vm._v("OAS")]), _vm._v(" "), _c('td', {
    staticClass: "noindent"
  }, [_vm._v("Organization of Arab Students")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eba9966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Abbreviations.vue
// module id = 78
// module chunks = 0